import script from "./RSEcard.vue?vue&type=script&setup=true&lang=ts"
export * from "./RSEcard.vue?vue&type=script&setup=true&lang=ts"

import "./RSEcard.vue?vue&type=style&index=0&id=355ea954&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-355ea954"]])

export default __exports__